module.exports = __webpack_public_path__ + "static/media/suggestion-design.6099f5fb.png";